'use strict';

import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import utilities from 'Shared/utilities';
let app = window.app;
export default class TextInput extends Component {
  state = {
    id: this.props.id || String(++app.form_index)
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onChange !== 'function') return;
    if (typeof props.value !== 'undefined') return;
    let value = props['default-value'] || '';
    if (props['auto-caps'] === true) {
      value = value.toUpperCase();
    }
    let returned_value = value;
    if (props['safe-value']) {
      const positive = props['allow-negative'] !== true;
      const int = props['int'] ? true : false;
      returned_value = utilities.cleanNumber(value, positive, int, props.digits);
    }
    props.onChange({
      e: null,
      value: returned_value,
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onChange !== 'function') return;
    let value = e.target.value;
    if (props['auto-caps'] === true) {
      value = value.toUpperCase();
    }
    let returned_value = value;
    if (props['safe-value']) {
      const positive = props['allow-negative'] !== true;
      const int = props['int'] ? true : false;
      returned_value = utilities.cleanNumber(value, positive, int, props.digits);
    }
    props.onChange({
      e: e,
      value: returned_value,
      name: props.name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let status = props.status[props.name];
    const error_msg = status?.error ? status.error : undefined;
    const prefix = props.prefix ? /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, props.prefix) : undefined;
    const suffix = props.suffix ? /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, props.suffix) : undefined;
    let class_list = props.className || (props.full_width ? 'u-full-width' : '');
    class_list = class_list.split(' ');
    if (!props.label) {
      class_list.push('textinput-without-label');
    }
    const text_field_component = /*#__PURE__*/React.createElement(TextField, {
      error: error_msg ? true : false,
      fullWidth: props.full_width,
      id: state.id,
      label: props.label,
      helperText: error_msg || props.helper_txt,
      variant: props.variant,
      color: props.color || 'primary',
      disabled: props['read-only'] === true,
      value: props.value || '',
      name: props.name,
      type: props.type,
      required: props.required || false,
      multiline: props.multiline,
      minRows: props.rows,
      autoComplete: props.autoComplete || props.autocomplete,
      onChange: component.handleChange,
      onBlur: props.onBlur,
      onFocus: props.onFocus,
      onKeyDown: props.onKeyDown,
      placeholder: props.placeholder,
      InputLabelProps: {
        className: 'mui-textinput-label mui-textinput-label--' + props.type
      },
      InputProps: {
        startAdornment: prefix,
        endAdornment: suffix,
        className: 'mui-textinput mui-textinput--' + props.type,
        inputComponent: props?.inputComponent
      },
      inputProps: {
        inputMode: props.inputMode,
        ref: props['input-ref'],
        'aria-labelledby': props['aria-labelledby'],
        min: props.min,
        max: props.max
      }
    });
    var output = /*#__PURE__*/React.createElement("div", {
      className: class_list.join(' ')
    }, text_field_component);
    return output;
  }
}
TextInput.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  full_width: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  input_format: PropTypes.object,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  status: PropTypes.object
};
TextInput.defaultProps = {
  full_width: true,
  type: 'text',
  multiline: false,
  rows: '1',
  'auto-caps': false,
  status: {}
};
